import { render, staticRenderFns } from "./ArticleMarket.vue?vue&type=template&id=f73a65ee&scoped=true"
import script from "./ArticleMarket.vue?vue&type=script&lang=js"
export * from "./ArticleMarket.vue?vue&type=script&lang=js"
import style0 from "./ArticleMarket.vue?vue&type=style&index=0&id=f73a65ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73a65ee",
  null
  
)

export default component.exports